module.exports = __webpack_public_path__ + "img/lose.742cf410.svg";